import { assignIfExists } from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { pruneTokenErrors } from '@/tokens/state/state';
import { datasetNotification } from './state';
import actions from '../constants';

const showDatasetNotificationCreate = withDraft((draft, action) => {
  draft.datasetNotification.open = true;
  draft.datasetNotification.code = action.code;
  draft.datasetNotification.datasetName = action.name;
});

const hideDatasetNotificationCreate = withDraft((draft) => { draft.datasetNotification = datasetNotification(); });

const updateDatasetNotificationCreateProperties = withDraft((draft, action) => {
  assignIfExists(draft.datasetNotification.update, action.properties);
  draft.datasetNotification.createErrors = pruneTokenErrors(draft.datasetNotification.createErrors, action);
});

const createDatasetNotification = withDraft((draft) => { draft.datasetNotification.createStatus = states.PENDING; });

const createDatasetNotificationSuccess = withDraft((draft) => { draft.datasetNotification = datasetNotification(); });

const createDatasetNotificationError = withDraft((draft, action) => {
  assignIfExists(draft.datasetNotification, {
    createStatus: states.ERROR,
    createErrors: [responseError(action)],
  });
});

export default {
  [actions.CREATE_DATASET_NOTIFICATION]: createDatasetNotification,
  [actions.CREATE_DATASET_NOTIFICATION_ERROR]: createDatasetNotificationError,
  [actions.CREATE_DATASET_NOTIFICATION_SUCCESS]: createDatasetNotificationSuccess,
  [actions.HIDE_DATASET_NOTIFICATION_CREATE]: hideDatasetNotificationCreate,
  [actions.SHOW_DATASET_NOTIFICATION_CREATE]: showDatasetNotificationCreate,
  [actions.UPDATE_DATASET_NOTIFICATION_CREATE_PROPERTIES]: updateDatasetNotificationCreateProperties,
};
